import { createAction } from 'redux-actions';

export const moduleName = 'faq';

export const FAQ_DETAIL_SELECT = `${moduleName}/FAQ_DETAIL_SELECT`;

export const switchDetail = createAction(
  FAQ_DETAIL_SELECT,
  payload => payload,
  () => ({ selfClosing: true }),
);

